<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <div>
                    <PlaceHolderLoader height="10px" width="80px" :custom-class="['mb-2 rounded']" />
                    <PlaceHolderLoader height="10px" width="150px" :custom-class="['mb-2 rounded']" />
                    <PlaceHolderLoader height="40px" width="100%" :custom-class="['rounded']" />
                </div>     

                <div class="mt-4">
                    <PlaceHolderLoader height="10px" width="80px" :custom-class="['mb-2 rounded']" />
                    <PlaceHolderLoader height="10px" width="150px" :custom-class="['mb-2 rounded']" />
                    <PlaceHolderLoader height="40px" width="100%" :custom-class="['rounded']" />
                </div>
                
                <div class="mt-4">
                    <div class="d-flex align-items-center">
                        <PlaceHolderLoader height="10px" width="50px" :custom-class="['rounded']" />
                        <PlaceHolderLoader height="10px" width="90px" :custom-class="['ml-2 rounded']" />
                    </div>
                    <PlaceHolderLoader height="10px" width="90px" :custom-class="['mt-2 rounded']" />
                </div>

                <div class="mt-4">
                    <PlaceHolderLoader height="10px" width="80px" :custom-class="['mb-2 rounded']" />
                    <PlaceHolderLoader height="10px" width="150px" :custom-class="['mb-2 rounded']" />
                    <PlaceHolderLoader height="40px" width="100%" :custom-class="['rounded']" />
                </div>

                <div class="mt-4">
                    <PlaceHolderLoader height="10px" width="80px" :custom-class="['mb-2 rounded']" />
                    <PlaceHolderLoader height="10px" width="150px" :custom-class="['mb-2 rounded']" />
                    <PlaceHolderLoader height="40px" width="100%" :custom-class="['rounded']" />
                </div>

                <div class="d-flex align-items-center mt-2">
                    <div v-for="index in 5">
                        <PlaceHolderLoader :class="{'ml-2' : index !== 1}" height="10px" width="80px" :custom-class="['mb-2 rounded']" />
                    </div>
                </div>

                <div class="mt-4">
                    <PlaceHolderLoader height="40px" width="150px" :custom-class="['rounded']" />
                </div>


            </div>
            <div class="col-md-3">
                <div class="d-flex align-items-center">
                    <PlaceHolderLoader height="10px" width="20px" :custom-class="['rounded']" />
                    <PlaceHolderLoader height="10px" width="100px" :custom-class="['ml-2 rounded']" />
                </div>
                <div class="d-flex align-items-center mt-3">
                    <PlaceHolderLoader height="10px" width="20px" :custom-class="['rounded']" />
                    <PlaceHolderLoader height="10px" width="100px" :custom-class="['ml-2 rounded']" />
                </div>
                <div class="d-flex align-items-center mt-3">
                    <PlaceHolderLoader height="10px" width="20px" :custom-class="['rounded']" />
                    <PlaceHolderLoader height="10px" width="100px" :custom-class="['ml-2 rounded']" />
                </div>
            </div>
        </div>
    </div>
  </template>
    
    <script lang="ts">
    export default {
      name: 'JobPreferences'
    }
    </script>
    
    <style lang="scss" scoped>
    </style>
